import { render } from "./EmailCompiler.vue?vue&type=template&id=47572946&scoped=true"
import script from "./EmailCompiler.vue?vue&type=script&lang=js"
export * from "./EmailCompiler.vue?vue&type=script&lang=js"

import "./EmailCompiler.vue?vue&type=style&index=0&id=47572946&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47572946"]])

export default __exports__